import React, { useState, useEffect, useRef } from 'react';
import api from '../utils/api';

const AddressPicker = ({ value, onChange }) => {
  const [options, setOptions] = useState([]);
  const prefilled = useRef(false);
  const valueRef = useRef(value);
  valueRef.current = value;

  useEffect(() => {
    let ok = true;
    const run = async () => {
      const opts = [];
      for (const ep of ['/organizations/mine', '/organizations', '/memberships/mine']) {
        try {
          const r = await api.get(ep);
          const list = Array.isArray(r.data) ? r.data : (r.data.organizations || r.data.orgs || []);
          if (list.length) {
            const o = list.find(x => x.my_role === 'manager' || x.role === 'manager') || list[0];
            const org = o.organization || o;
            const addr = [org.address, org.location].filter(Boolean).join(', ');
            if (addr) opts.push({ addr, barn: true });
            break;
          }
        } catch (e) {}
      }
      for (const ep of ['/farrier/appointments', '/appointments']) {
        try {
          const r = await api.get(ep);
          const list = Array.isArray(r.data) ? r.data : (r.data.appointments || []);
          list.forEach(a => {
            if (a && a.location && !opts.some(o => o.addr.toLowerCase() === a.location.toLowerCase())) {
              opts.push({ addr: a.location, barn: false });
            }
          });
          break;
        } catch (e) {}
      }
      if (!ok) return;
      setOptions(opts.slice(0, 8));
      if (!prefilled.current && opts.length && opts[0].barn && !(valueRef.current || '').trim()) {
        prefilled.current = true;
        onChange(opts[0].addr);
      }
    };
    run();
    return () => { ok = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selected = options.some(o => o.addr === value) ? value : '';

  return (
    <>
      <div className="form-group">
        <label className="form-label">Saved address</label>
        <select className="form-input" value={selected} onChange={(e) => { if (e.target.value) onChange(e.target.value); }}>
          <option value="">Choose saved address or enter manually</option>
          {options.map((o, i) => (
            <option key={o.addr + i} value={o.addr}>{o.addr}{o.barn ? ' (your barn)' : ''}</option>
          ))}
        </select>
        <p style={{ fontSize: 12.5, color: 'var(--text-secondary)', margin: '6px 0 0' }}>Your barn address plus addresses from past requests.</p>
      </div>
      <div className="form-group">
        <label className="form-label">Location</label>
        <input className="form-input" type="text" value={value} onChange={(e) => onChange(e.target.value)} placeholder="Barn address or notes" autoComplete="off" />
        <p style={{ fontSize: 12.5, color: 'var(--text-secondary)', margin: '6px 0 0' }}>New addresses entered here are remembered after you use them.</p>
      </div>
    </>
  );
};

export default AddressPicker;
